import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import { CustomSwal } from '../../../../components/CustomFeedback/CustomSwal';
import DetailsTable from '../../../../components/CustomTable/DetailsTable';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useSelect } from '../../../../modules/contexts/Select/useSelect';
import { getActsByUsuario } from '../../../../services/acts/actsService';
import theme from '../../../../theme';
import {
  formataNomeMeioSiglas,
  formatDate,
  formatDateSimp,
} from '../../../../utils/functions';
import { SubAbas as subAbas } from '../subabas';
import {
  ActsTableRow,
  headersActs,
  headersActsCustomTable,
  valoresExibidosOffCanvasActs,
} from './auxiliarActs';
import CustomTableOffcanvas from '../../../../components/CustomTableOffcanvas';

const ActsIndex: React.FC = () => {
  //DADOS USUARIO
  const user = getUser();
  const userComponenteAFLabel =
    user?.vinculo?.[0]?.nomeInstituicao ?? 'Não informado';
  const userComponenteAf = Number(user.vinculo[0].numeroComponenteAF);

  const navigate = useNavigate();
  //OPTIONS
  const { getSelectDominioPai } = useSelect();
  const statusActOptions = getSelectDominioPai(52);
  const componenteAFoptions = getSelectDominioPai(1);

  const [data, setData] = useState<any[]>([]);

  // Buscar dados
  const fetchData = async () => {
    try {
      const registros = await getActsByUsuario();
      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  // TABELA E OFFCANVAS
  const tableData = data.map((item) => ({
    id: item?.id ?? 'Não informado',

    status:
      statusActOptions.find((status) => status.value === item.statusAct)
        ?.label ?? 'Não informado',
    componenteAf:
      componenteAFoptions.find(
        (componenteAf) => componenteAf.value === item.componenteAf,
      )?.label ?? 'Não informado',
    numeroAct: item.numeroAct ?? 'Não informado',
    fornecedor:
      '[' + item.fornecedor?.cnpj + '] - ' + item.fornecedor?.nomeFantasia,
  }));

  const offCanvasData = data.map((item) => {
    // Definindo cores de fundo com base no status do documento
    let statusBackgroundColor = '';
    let colorText = 'white';

    const statusLabel = statusActOptions.find(
      (option) => option.value === item.statusAct,
    )?.label;

    if (statusLabel === 'Em Elaboração') {
      statusBackgroundColor = theme.colors.amarelogov;
      colorText = 'white';
    } else if (statusLabel === 'Em Execução') {
      statusBackgroundColor = theme.colors.verdegov;
      colorText = 'white';
    } else if (statusLabel === 'Encerrado') {
      statusBackgroundColor = theme.colors.azulgov;
      colorText = 'white';
    } else if (statusLabel === 'Suspenso') {
      statusBackgroundColor = theme.colors.laranja;
      colorText = 'white';
    } else if (statusLabel === 'Cancelado') {
      statusBackgroundColor = theme.colors.vermelho;
      colorText = 'white';
    }

    const componenteSigla = componenteAFoptions
      .find((option) => option.value === item.componenteAf)
      ?.label.slice(0, 1)
      .toUpperCase();

    let componenteBackgroundColor = '';
    if (item.componenteAf === 1) {
      componenteBackgroundColor = theme.colors.azulgov;
    } else if (item.componenteAf === 2) {
      componenteBackgroundColor = theme.colors.amarelogov;
    } else if (item.componenteAf === 3) {
      componenteBackgroundColor = theme.colors.verdegov;
    }

    return {
      id: item.id,
      dataRegistro:
        formatDate(item.dataRegistro) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
      dataUltimaAtualizacao:
        formatDate(item.dataUltimaAtualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),

      dataUltimaVisualizacao:
        formatDate(item.dataUltimaVisualizacao) +
        ' - ' +
        formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
      nEdicoes: item.nEdicoes,
      nVisualizacoes: item.nVisualizacoes,
      separadorLog: '',
      statusAct: (
        <span
          style={{
            backgroundColor: statusBackgroundColor,
            color: colorText,
            borderRadius: '10px',
            padding: '12px',
            display: 'inline-block',
            minWidth: '100px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
        >
          {statusLabel}
        </span>
      ),
      componenteAf: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
          }}
        >
          <span
            style={{
              backgroundColor: componenteBackgroundColor,
              color: colorText,
              borderRadius: '10px',
              padding: '12px',
              display: 'inline-block',
              textAlign: 'center',
              fontWeight: 'bold',
            }}
          >
            {componenteSigla}
          </span>
          <span style={{ marginLeft: '8px' }}>
            {
              componenteAFoptions.find(
                (option) => option.value === item.componenteAf,
              )?.label
            }
          </span>
        </div>
      ),
      //numeroSeiArp: item.numeroSeiArp,
      numeroAct: item.numeroAct,
      dataDou: formatDateSimp(item.dataDou),
      dataInicio: formatDateSimp(item.dataInicio),
      dataVigencia: formatDateSimp(item.dataVigencia),
      fornecedor: '-',
      nProdutos: <span>0</span>,
      valorTotal: <span>0</span>,

      //Observações
      separadorObservacoes: '',
      observacoes: item.observacoes,
    };
  });

  const handleClickInserir = () => {
    if (
      ['Gabinete', 'Coordenação de Fiscalização de Contratos'].includes(
        userComponenteAFLabel,
      )
    ) {
      CustomSwal.show({
        type: 'warning',
        title: 'Atenção',
        html: 'Usuários vinculados ao Gabinete ou à Coordenação de Fiscalização de Contratos não podem criar ACTs.',
        showConfirmButton: true,
      });
      return;
    }
    navigate('dadosgerais', { state: { userComponenteAf } });
  };

  const [selectedDetailsRowId, setSelectedDetailsRowId] = useState<
    string | number | null
  >(null);
  const offcanvasOpenRoute = useMemo(() => {
    if (!selectedDetailsRowId) return undefined;

    const baseHash = window.location.hash.replace(/\/$/, '');
    return `${baseHash}/${selectedDetailsRowId}/dadosgerais`;
  }, [selectedDetailsRowId]);

  const handleOpenDetails = (row: ActsTableRow) => {
    if (!row?.id) return;
    setSelectedDetailsRowId(row.id);
  };

  const handleTableRowClick = (row: ActsTableRow) => {
    if (row?.id) {
      navigate(`${row.id}/dadosgerais`);
    }
  };

  return (
    <>
      <BarraSubAbas subAbas={subAbas} />

      <ContainerConteudo>
        <CustomTableOffcanvas
          headers={headersActsCustomTable}
          data={tableData}
          displayValues={valoresExibidosOffCanvasActs}
          offcanvasTitle="Detalhes do ACT"
          widthOffcanvas="50%"
          openRoute={offcanvasOpenRoute}
          onOpenOffcanvas={handleOpenDetails}
          onRowClick={handleTableRowClick}
          itemsPerPage={50}
          // emptyMessage="Carregando..."
          showPagination={true}
          showOpenButton={true}
          filterable={true}
        >
          {(row) => (
            <DetailsTable
              rows={offCanvasData}
              selectedId={row?.id ?? selectedDetailsRowId}
              displayValues={valoresExibidosOffCanvasActs}
            />
          )}
        </CustomTableOffcanvas>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          // download
          // downloadDisabled={isExporting || !(data.length > 0)}
          // onClickDownload={handleExport}
          inserir
          onClickInserir={handleClickInserir}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default ActsIndex;
